import { createContext, useEffect, useState } from "react";

const AppLayoutContext = createContext();
const { Provider } = AppLayoutContext;

const AppLayoutProvider = ({ children }) => {
  /** */

  // Screen Width
  const [dimensions, setDimensions] = useState({ height: window.innerHeight, width: window.innerWidth });

  // Notification Drawer
  const [notification, setNotification] = useState({ enabled: false });

  // Window Size Change Handler
  useEffect(() => {
    /** */

    // Handle Window Resize
    const handleWindowSizeChange = () => setDimensions({ height: window.innerHeight, width: window.innerWidth });

    // Add Event Listeners
    window.addEventListener("resize", handleWindowSizeChange);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };

    /** */
  }, []);

  const components = {
    notification: {
      enabled: notification.enabled,
      show: () => setNotification(() => ({ enabled: true })),
      close: () => setNotification(() => ({ enabled: false })),
    },
  };

  return (
    <Provider
      value={{
        ...components,
        dimensions,
        isMobile: dimensions.width < 768,
      }}
    >
      {children}
    </Provider>
  );
};
export { AppLayoutContext, AppLayoutProvider };
